import axios from "axios";
import { matchHLATyping } from "./MatchScores";

const HLAMatchScore = (recipient, donor) => {
  return new Promise((resolve, reject) => {
    console.log("Calculating HLA Match Score for:", recipient, donor);

    const getClinicalRecords = () => {
      let userToken = localStorage.getItem("token");
      let urlLink = `${process.env.REACT_APP_API_URL}/clinical/clinical-pair/`;
      console.log("API URL:", urlLink); // Log the API URL for debugging

      const config = {
        method: "post",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        data: { recipient_id: recipient, donor_id: donor },
      };

      axios(config)
        .then(function (response) {
          console.log("API Response:", response.data);
          if (
            response.data?.recipient_clinical &&
            response.data?.donor_clinical
          ) {
            const result = matchHLATyping(
              response.data.recipient_clinical,
              response.data.donor_clinical
            );
            resolve(result.matchPercentage);
          } else {
            console.warn("Incomplete clinical data received");
            resolve(0);
          }
        })
        .catch(function (err) {
          console.error(
            "API call error:",
            err.response?.status,
            err.response?.data
          );
          if (err.response?.status === 404) {
            console.error(
              "API endpoint not found. Please check the URL:",
              urlLink
            );
          }
          resolve(0); // Resolve with 0 instead of rejecting to avoid breaking the UI
        });
    };

    getClinicalRecords();
  });
};

export default HLAMatchScore;
